import {
  REQUEST_HOLIDAY,
  REQUEST_HOLIDAY_SUCCESS,
  REQUEST_HOLIDAY_FAILURE,
  REQUEST_HOLIDAY_OVERVIEW,
  REQUEST_HOLIDAY_OVERVIEW_SUCCESS,
  REQUEST_HOLIDAY_OVERVIEW_FAILURE,
  SET_HOLIDAY_INFO,
  FETCH_HOLIDAY_BY_YEAR,
  FETCH_HOLIDAY_BY_YEAR_SUCCESS,
  FETCH_HOLIDAY_BY_YEAR_FAILURE,
} from '../constants/ActionTypes';

const initialState = {
  loaded: true,
  error: null,
  hasError: false,
  holidays: [],
  payYear: 0,
  holidayOverview: {},
  overviewError: null,
  overviewLoaded: false,
  holidayInfo: null,
  initialized: false,
  loading: false,
  fetchingByYear: false,
  holidayCheckInfo: {},
};
export default function EmployeeHolidayReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_HOLIDAY: {
      return {
        ...state,
        loaded: false,
        loading: true,
        hasError: false,
        error: null,
      };
    }
    case REQUEST_HOLIDAY_SUCCESS:
      return {
        ...state,
        initialized: true,
        loading: false,
        loaded: true,
        holidays: action.holidays,
        holidayCheckInfo: action.holidayCheckInfo,
        earnedHolidayInfo: action.earnedHolidayInfo,
      };
    case REQUEST_HOLIDAY_FAILURE:
      return {
        ...state,
        initialized: true,
        loading: false,
        loaded: true,
        error: action.error,
        hasError: true,
      };
    case REQUEST_HOLIDAY_OVERVIEW: {
      return {
        ...state,
        overviewLoaded: false,
      };
    }
    case REQUEST_HOLIDAY_OVERVIEW_SUCCESS:
      return {
        ...state,
        holidayOverview: action.holidayOverview,
        overviewLoaded: true,
      };
    case REQUEST_HOLIDAY_OVERVIEW_FAILURE:
      return {
        ...state,
        overviewError: action.error,
      };
    case SET_HOLIDAY_INFO:
      return {
        ...state,
        holidayInfo: action.holidayInfo,
      };
    case FETCH_HOLIDAY_BY_YEAR:
      return {
        ...state,
        fetchedByYear: false,
        fetchingByYear: true,
        hasError: false,
        error: null,
        payYear: action.year,
      };
    case FETCH_HOLIDAY_BY_YEAR_SUCCESS:
      return {
        ...state,
        fetchingByYear: false,
        fetchedByYear: true,
        holidays: action.holidays,
        holidayOverview: action.holidaysOverview,
      };
    case FETCH_HOLIDAY_BY_YEAR_FAILURE:
      return {
        ...state,
        fetchingByYear: false,
        fetchedByYear: true,
        error: action.error,
        hasError: true,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/EmployeeHolidayReducer.js